import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/functions';

const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

firebase.initializeApp(config);

const auth = firebase.auth();
const database = firebase.database();
const db = firebase.firestore();

if (
  location.hostname === 'localhost' &&
  process.env.NODE_ENV !== 'production'
) {
  auth.useEmulator('http://localhost:9099');
  database.useEmulator('localhost', 9000);
  db.useEmulator('localhost', 8000);
  firebase.functions().useEmulator('localhost', 5001);
}

export { database, db, firebase };
